import { Extension } from "@tiptap/core"
import { Plugin, PluginKey } from "@tiptap/pm/state"
import { Decoration, DecorationSet } from "@tiptap/pm/view"

/** Use with `tr.setMeta(linkPanelHighlightDecorationKey, { from, to })` while a link URL panel is open. */
export const linkPanelHighlightDecorationKey = new PluginKey("linkPanelHighlightDecoration")

/**
 * Inline decoration for the active selection while editing a link in a floating panel
 * (keeps the range visible after focus moves to the URL field).
 */
export const LinkPanelHighlight = Extension.create({
  name: "linkPanelHighlight",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: linkPanelHighlightDecorationKey,
        state: {
          init: () => DecorationSet.empty,
          apply(tr, old) {
            const meta = tr.getMeta(linkPanelHighlightDecorationKey)
            const mapped = old.map(tr.mapping, tr.doc)
            if (meta === false) {
              return DecorationSet.empty
            }
            if (meta?.from != null && meta?.to != null && meta.to > meta.from) {
              return DecorationSet.create(tr.doc, [
                Decoration.inline(meta.from, meta.to, { class: "tiptap-link-panel-highlight" }),
              ])
            }
            return mapped
          },
        },
        props: {
          decorations(state) {
            return this.getState(state)
          },
        },
      }),
    ]
  },
})
